<div class="flex flex-col gap-2">
  <h2 class="text-2xl font-bold mb-4">Faktagranskning och källhänvisningar</h2>

  <div class="flex flex-col md:flex-row justify-start items-start gap-0 md:gap-8">
    <div class="basis-full max-w-full md:basis-36 md:max-w-36 w-full md:w-36">Publicerad:</div>
    <div class="grow">{{ publishDateFull() }}</div>
  </div>

  <div class="flex flex-col md:flex-row justify-start items-start gap-0 md:gap-8">
    <div class="basis-full max-w-full md:basis-36 md:max-w-36 w-full md:w-36">Uppdaterad:</div>
    <div class="grow">{{ updateDateFull() }}</div>
  </div>

  <div class="flex flex-col md:flex-row justify-start items-start gap-0 md:gap-8">
    <div class="basis-full max-w-full md:basis-36 md:max-w-36 w-full md:w-36">Författare:</div>
    <div class="grow">
      @for (authorItem of authorToDisplay(); let last = $last; track authorItem.ID) {
        <a [innerHTML]="authorItem.display_name"
           [routerLink]="authorItem.routerLink"></a>@if (!last || (authorName() != null && authorName() !== '')) {
          ,
        }
      }
      @if (authorName() != null && authorName() !== '') {
        {{ authorName() }}
      }
    </div>
  </div>

  <div class="flex flex-col md:flex-row justify-start items-start gap-0 md:gap-8">
    <div class="basis-full max-w-full md:basis-36 md:max-w-36 w-full md:w-36">Faktagranskad av:</div>
    <div [innerHTML]="factChecker() | wpMediaUrlFix | safeHtml" class="grow description basis-0"></div>
  </div>

  <div class="flex flex-col md:flex-row justify-start items-start gap-0 md:gap-8">
    <div class="basis-full max-w-full md:basis-36 md:max-w-36 w-full md:w-36">Källor:</div>
    <div [innerHTML]="sources() | wpMediaUrlFix | safeHtml" class="grow description   basis-0"></div>
  </div>

</div>
